<mat-list>
  <h3 mat-subheader>Notifications</h3>
  <mat-divider></mat-divider>
  <ng-container *ngIf="sessionService.getNotifications() == undefined || sessionService.getNotifications()?.length == 0">
    <mat-list-item>
      You have no notifications
    </mat-list-item>
  </ng-container>
  <ng-container *ngFor="let notification of sessionService.getNotifications()">
    <mat-list-item class="selectable" (click)="display(notification)">
      <mat-icon *ngIf="notification.type == 'COMPLETED_ASSESSMENT' || notification.type == 'NEW_ASSESSMENT'" mat-list-icon [ngClass]="{'notification-read': notification.isRead, 'text-primary': !notification.isRead}" svgIcon="cw:action_toggle_graph">
      </mat-icon>

      <mat-icon *ngIf="notification.type == 'COMPLETED_SCAN'" mat-list-icon [ngClass]="{'notification-read': notification.isRead, 'text-primary': !notification.isRead}">
        policy
      </mat-icon>

      <mat-icon *ngIf="notification.type == 'SYSTEM_ALERT'" mat-list-icon [ngClass]="{'notification-read': notification.isRead, 'text-primary': !notification.isRead}">
        info
      </mat-icon>
      <mat-icon *ngIf="notification.type == 'INFORMATIONAL' || notification.type == 'MARKETING'" mat-list-icon [ngClass]="{'notification-read': notification.isRead, 'text-primary': !notification.isRead}">
        <ng-container *ngIf="notification.isRead">drafts</ng-container>
        <ng-container *ngIf="!notification.isRead">mail</ng-container>
      </mat-icon>
      <h4 mat-line class="message-text" [ngClass]="{'notification-read': notification.isRead, 'text-primary': !notification.isRead}">{{notification.subject}}</h4>
      <span mat-line class="mat-subtitle" [ngClass]="{'notification-read': notification.isRead}" style="font-style:italic" *ngIf="notification.type == 'NEW_ASSESSMENT'">New Assessment</span>
      <span mat-line class="mat-subtitle" [ngClass]="{'notification-read': notification.isRead}" style="font-style:italic" *ngIf="notification.type == 'COMPLETED_ASSESSMENT'">Completed Assessment</span>
      <span mat-line class="mat-subtitle" [ngClass]="{'notification-read': notification.isRead}" style="font-style:italic">
        {{notification.createdAt | date:'short'}}
      </span>
      <!-- <mat-icon [ngClass]="{'notification-read': notification.isRead, 'text-primary': !notification.isRead}" svgIcon="cw:flag_enabled"></mat-icon> -->
    </mat-list-item>
    <mat-divider></mat-divider>
  </ng-container>
</mat-list>